import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { NotificationDTO, NotificationSeverity } from '../../../core/models/notification.types';
import { TranslocoDirective } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-notification-toast',
    templateUrl: './notification-toast.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatIconModule, MatButtonModule, TranslocoDirective, DatePipe],
    styles: [`
        .notification-toast-panel {
            margin-bottom: 16px !important;
            margin-right: 16px !important;
        }
        .notification-toast-panel .mdc-snackbar__surface {
            background-color: transparent !important;
            background: transparent !important;
            box-shadow: none !important;
            padding: 0 !important;
            border-radius: 0 !important;
        }
        .notification-toast-panel .mat-mdc-snack-bar-label {
            padding: 0 !important;
        }
    `]
})
export class NotificationToastComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public notification: NotificationDTO,
        private snackBarRef: MatSnackBarRef<NotificationToastComponent>,
        private router: Router
    ) { }

    get iconConfig(): { icon: string, borderClass: string, bgClass: string, textClass: string } {
        switch (this.notification.severity) {
            case NotificationSeverity.SUCCESS:
                return { icon: 'heroicons_outline:check-circle', borderClass: 'bg-green-500', bgClass: 'bg-green-100 dark:bg-green-900/40', textClass: 'text-green-600 dark:text-green-400' };
            case NotificationSeverity.WARNING:
                return { icon: 'heroicons_outline:exclamation-triangle', borderClass: 'bg-amber-500', bgClass: 'bg-amber-100 dark:bg-amber-900/40', textClass: 'text-amber-600 dark:text-amber-400' };
            case NotificationSeverity.ERROR:
                return { icon: 'heroicons_outline:x-circle', borderClass: 'bg-red-500', bgClass: 'bg-red-100 dark:bg-red-900/40', textClass: 'text-red-600 dark:text-red-400' };
            case NotificationSeverity.INFO:
            default:
                return { icon: 'heroicons_outline:information-circle', borderClass: 'bg-blue-500', bgClass: 'bg-blue-100 dark:bg-blue-900/40', textClass: 'text-blue-600 dark:text-blue-400' };
        }
    }

    onNotificationClick(): void {
        if (this.notification.actionUrl) {
            this.router.navigateByUrl(this.notification.actionUrl);
            this.snackBarRef.dismiss();
        }
    }

    closeTask(event: Event): void {
        event.stopPropagation();
        this.snackBarRef.dismiss();
    }
}
